// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  // envName: 'qa',
  // BASE_URL: "http://172.16.50.89:8080",

  // envName: 'demo2',
  //BASE_URL:"https://odinconnector-api-uat.63moons.com",
  //for node
  // BASE_URL:"https://1qluk40xr0.execute-api.ap-south-1.amazonaws.com/uat",

 
   

  //envName: 'dev',//
  //BASE_URL: "https://5j338tply8.execute-api.ap-south-1.amazonaws.com/dev",

  //envName: 'dev',
  //BASE_URL : "15.206.149.60:8080",
  // envName: 'prod2',
  // BASE_URL:"https://odinconnector-api.63moons.com",

  // BASE_URL_CDN: "http://dchjc0e2km5t.cloudfront.net",

  // messages:{ "COMMON_PAGE_ACCESS_DENIED":"You do not have access to this page",
  // "CALL_PAGE_ACCESS_DENIED":"Call page is not accessible to operation user",
  // "DISCLAIMER_REPORT":" Success Rate is calculated excluding Open Calls."
  //   },

  // config:{
  //   "logoURLPath":"https://bts-vas-marketplace.s3.ap-south-1.amazonaws.com/market-place/uat/tenant/images/"
  // },

  // S3_BUCKEt_URL: 'https://bts-vas-marketplace.s3.ap-south-1.amazonaws.com/market-place/uat/'



};

